import { useState, useEffect } from "react";
import "./AskedQuestionsTable.css";
import { useSelector } from "react-redux";
import { selectUser, setSelectedSubMenu } from "../../redux/features/appData";
import {
  apiAIGetResponseSaves,
  apiAIGetResponseSavesForUserInCollection,
  apiAIGetResponseSavesVisibleToUserInWorkspace,
} from "../../services/AIService";
import { AIResponseSave } from "winslow-core";
import { formatDate } from "winslow-core";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { MENUS } from "../config/menus";

type AskedQuestionsTableProps = {
  collectionId?: string | undefined;
  showAllPossible?: boolean;
};

export const AskedQuestionsTable = ({
  collectionId = undefined,
  showAllPossible = false,
}: AskedQuestionsTableProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storeUser = useSelector(selectUser);
  const [theQuestions, setTheQuestions] = useState<AIResponseSave[] | null>(
    null
  );

  useEffect(() => {
    if (!theQuestions) {
      (async () => {
        let newQuestions: AIResponseSave[] | null = null;

        // this is if we're getting all for a user
        if (
          storeUser &&
          storeUser.currentWorkspaceId &&
          !collectionId &&
          !showAllPossible
        ) {
          newQuestions = await apiAIGetResponseSaves(
            storeUser.id,
            storeUser.currentWorkspaceId
          );
        } else if (storeUser && collectionId && !showAllPossible) {
          newQuestions = await apiAIGetResponseSavesForUserInCollection(
            storeUser.id,
            collectionId
          );
        } else if (storeUser && showAllPossible) {
          newQuestions = await apiAIGetResponseSavesVisibleToUserInWorkspace(
            storeUser.id,
            storeUser?.currentWorkspaceId || ""
          );
        }

        if (newQuestions) {
          newQuestions.sort((a: any, b: any) => {
            return (
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );
          });

          setTheQuestions([...newQuestions] as any);
        }
      })();
    }
  });

  return (
    <table id="asked-questions-table">
      <thead>
        <tr>
          <th>Question Asked</th>
          <th>Date</th>
          <th>Collection</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        {theQuestions &&
          theQuestions.length > 0 &&
          theQuestions.map((question: AIResponseSave) => {
            return (
              <tr
                key={"asked-questions-row-" + question.id}
                id="asked-questions-table-tr"
                onClick={() => {
                  dispatch(setSelectedSubMenu(MENUS.COLLECTION_ASK));
                  navigate(
                    "/collection/" +
                      question.collectionId +
                      "/ask/" +
                      question.id
                  );
                }}>
                <td>{question.question}</td>
                <td>{formatDate(new Date(question.createdAt))}</td>
                <td>
                  {question.collection ? question.collection.title : "unknown"}
                </td>
                <td>&nbsp;</td>
              </tr>
            );
          })}
        {theQuestions && theQuestions.length === 0 && (
          <tr id="asked-questions-table-tr">
            <td>No questions history yet.</td>
            <td>{}</td>
            <td>{}</td>
            <td>&nbsp;</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
